import React, {Fragment, useRef, useState} from "react";
import {Tab} from "@headlessui/react";
import JobTable from "./JobTable";
import CreateJob, {JobStatus} from "./createjob";
import LabController from "../../controllers/LabController";
import {classes} from "../Leafs";

export interface JobTableFunctions {
    refresh: () => void;
}


const LabJobs: React.FC = () => {
    const jobTableRef = useRef<JobTableFunctions>()
    const [jobId, setJobId] = useState<JobStatus>('closed')

    function createJob() {
        setJobId('create')
    }

    function refreshJob() {
        jobTableRef.current?.refresh()
    }

    return (
        <div>
            <button
                onClick={createJob} className="btn btn-primary my-2">Create Job
            </button>
            <Tab.Group refName='componentRef' defaultIndex={-1}>
                <Tab.List className="flex space-x-1 rounded-xl bg-primary-500 p-1">
                    <Tab as={Fragment}>
                        {({selected}) => (
                            <button
                                className={classes(selected)}
                            >
                                CURRENT
                            </button>
                        )}
                    </Tab>
                    <Tab as={Fragment}>
                        {({selected}) => (
                            <button
                                className={classes(selected)}
                            >
                                COMPLETED
                            </button>
                        )}
                    </Tab>
                    <Tab as={Fragment}>
                        {({selected}) => (
                            <button
                                className={classes(selected)}
                            >
                                DOWNLOADED
                            </button>
                        )}
                    </Tab>
                </Tab.List>
                <Tab.Panels>
                    <Tab.Panel>
                        <JobTable completed={false} archived={false} componentRef={jobTableRef} call={LabController.jobs}/>
                    </Tab.Panel>
                    <Tab.Panel>
                        <JobTable completed={true} archived={false} componentRef={jobTableRef} call={LabController.jobsCompleted}/>
                    </Tab.Panel>
                    <Tab.Panel>
                        <JobTable completed={true} archived={true} canPost={true} componentRef={jobTableRef} call={LabController.jobsArchived}/>
                    </Tab.Panel>
                </Tab.Panels>
            </Tab.Group>
            <CreateJob 
                jobId={jobId} 
                setModelValue={show => {
                   if (!show) {
                       refreshJob()
                       setJobId('closed')
                   }
                }} />
        </div>
    )
}

export default LabJobs
;
